import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onMounted, ref, onUnmounted, watch } from "vue";
import * as echarts from "echarts";
import { debounce } from "lodash-es";
export default {
  __name: 'echart-common',
  props: ["idname", "option", "height", "width"],
  setup(__props) {
    var echartRef = ref(null);
    var myChart = null;
    var prop = __props;
    var set_pei_data = () => {
      if (myChart) {
        myChart.setOption(prop.option, true); // 第二个参数 true 表示合并配置
      }
    };

    // 窗口 resize 处理函数
    var handleResize = () => {
      if (myChart) {
        myChart.resize();
      }
    };
    var debouncedResize = debounce(handleResize, 300);
    onMounted(() => {
      if (echartRef.value) {
        myChart = echarts.init(echartRef.value);
        set_pei_data();
        window.addEventListener("resize", debouncedResize);
      }
    });
    onUnmounted(() => {
      window.removeEventListener("resize", debouncedResize);
      debouncedResize.cancel(); // 取消防抖任务
    });
    watch(() => prop.option, val => {
      set_pei_data();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "echartRef",
        ref: echartRef,
        style: _normalizeStyle({
          height: __props.height + 'px',
          width: __props.width ? __props.width + 'px' : '100%'
        })
      }, null, 4);
    };
  }
};